/** Texts of the „Moje konto“ pages (Figma section „Moje konto“ 60263:35256). */
export const ACCOUNT_COPY = {
  account: 'Moje konto',
  nav: {
    label: 'Moje konto',
    openMenu: 'Otvoriť menu Moje konto',
    signOut: 'Odhlásiť sa',
    loyaltyPoints: (points: string) => `${points} vernostných bodov`,
    loyaltyValue: (value: string) => `= zľava ${value} na ďalší nákup`,
  },
  pages: {
    profile: {
      label: 'Môj profil',
      description:
        'Údaje použijeme pri vašich ďalších objednávkach. Zmeny sa prejavia pri najbližšom nákupe.',
    },
    password: {
      label: 'Zmena hesla',
      description: 'Silné heslo chráni vaše objednávky, adresy aj vernostné body.',
    },
    orders: {
      label: 'Moje objednávky',
      description: 'Prehľad všetkých objednávok, faktúr a stavu doručenia.',
    },
    favorites: {
      label: 'Obľúbené produkty',
      description: 'zoznam je uložený vo vašom účte, uvidíte ho na každom zariadení.',
    },
  },
  orderCrumb: (identifier: string) => `Č. ${identifier}`,
} as const;
